/* CG mobile: after Add to Cart, route the shopper to /cart.
   Watches the theme's live cart-count badge, so it fires the moment the item lands in the cart —
   works on any connection speed and regardless of which button/app performed the add. v5 (2026-07-30) */
(function () {
  var MQ = '(max-width: 767px)';
  function isMobile() { return window.matchMedia(MQ).matches; }
  var redirected = false;
  function goToCart() { if (redirected || !isMobile()) return; redirected = true; window.location.href = '/cart'; }
  function num(t) { var n = parseInt((t || '').replace(/[^0-9]/g, ''), 10); return isNaN(n) ? 0 : n; }

  function init() {
    // PRIMARY: the theme's cart-count badge updates the instant an add completes.
    // Watching it means we redirect as soon as the item is in the cart — no fixed timeout.
    var badge = document.querySelector('[data-js-cart-count]');
    var baseline = badge ? num(badge.textContent) : 0;
    if (badge) {
      new MutationObserver(function () {
        if (isMobile() && num(badge.textContent) > baseline) goToCart();
      }).observe(badge, { childList: true, characterData: true, subtree: true });
    }

    // BACKUP: the theme's confirmation popup / quick cart becoming active also means an add happened.
    ['.purchase-confirmation-popup', '.quick-cart'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      new MutationObserver(function () { if (el.classList.contains('active')) goToCart(); })
        .observe(el, { attributes: true, attributeFilter: ['class'] });
    });

    // BACKUP: after an add-to-cart interaction, poll the cart for up to ~30s (slow-connection safety net).
    function pollCart() {
      if (!isMobile()) return;
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (c.item_count > baseline) { clearInterval(iv); goToCart(); }
            else if (tries >= 60) { clearInterval(iv); }
          })
          .catch(function () {});
      }, 500);
    }
    function isAdd(el) { return el && el.closest && el.closest('button[name="add"], .product-form__cart-submit, [data-add-to-cart]'); }
    document.addEventListener('click', function (e) { if (isMobile() && isAdd(e.target)) pollCart(); }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (isMobile() && f && f.getAttribute && (f.getAttribute('action') || '').indexOf('/cart/add') !== -1) pollCart();
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();